import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('footer');
  return (
    <footer className="footer">
      <div className="footer-container">
        <nav className="footer-links" aria-label={t('ariaLabel')}>
          <Link to="/terms">{t('terms')}</Link>
          <span className="divider">|</span>
          <Link to="/legal/specified-commercial-transactions">{t('specifiedCommercial')}</Link>
          <span className="divider">|</span>
          <Link to="/privacy">{t('privacy')}</Link>
          <span className="divider">|</span>
          <Link to="/faq">{t('faq')}</Link>
          <span className="divider">|</span>
          <Link to="/contact">{t('contact')}</Link>
        </nav>
        <div className="footer-logo-copyright">
          <img
            src="/icons/footerlogo.svg"
            alt={t('logoAlt')}
            className="footer-logo-image"
          />
          <span className="footer-copyright-inline">© IRIE TIX All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;